<style lang="less" rel="stylesheet/less" scope>
body {
  background-color: #fff;
}
.recover-wrapper {
  .content {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 600px;
    min-height: 450px;
    padding: 15px;
    margin-top: -275px;
    margin-left: -300px;
  }
}
</style>
<template>
  <div class="recover-wrapper">
    <ly-layout-platform has-logout></ly-layout-platform>
    <div class="content">
      <el-form
        class="content-form"
        :model="formData"
        ref="formData"
        :rules="rules"
        label-width="100px"
      >
        <el-form-item label="用户名：" required prop="loginName">
          <el-input
            placeholder="请输入用户名"
            v-model.trim="formData.loginName"
            type="loginName"
            v-input-trim
          ></el-input>
        </el-form-item>
        <el-form-item label="原密码：" required prop="oldPassword">
          <el-input
            placeholder="请输入原密码"
            v-model="formData.oldPassword"
            required
            type="password"
            v-input-trim
          ></el-input>
        </el-form-item>
        <el-form-item label="新密码：" required prop="password">
          <el-input
            placeholder="请输入新密码"
            v-model="formData.password"
            required
            type="password"
            v-input-trim
          ></el-input>
        </el-form-item>
        <el-form-item label="确认密码：" required prop="checkWord">
          <el-input
            placeholder="请再次输入密码"
            v-model="formData.checkWord"
            type="password"
            v-input-trim
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="makeSure('formData')"
            >保 存</el-button
          >
          <el-button
            tag="button"
            class="el-button el-button--default el-button--small"
            @click="handleLogin"
          >
            取 消
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>
<script type="text/ecmascript-6">
import { logout } from '@/utils/logout'
import { recover } from '@/utils/rule-mixin'
import { getUserEmail, updateFirstLogin , checkOldPassword } from '@/api/login'
import checkPasswordMixins from '@/utils/checkPassword';
export default  {
  mixins: [checkPasswordMixins],
  data() {
    var validateNewPass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入新密码'));
        return
      } else if (value == this.formData.oldPassword) {
        callback(new Error('旧密码不能与新密码一致!'));
        return
      } else {
        this.$refs.formData.validateField('checkWord');
        callback();
      }
    };
    var validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请再次输入密码'));
        return
      } else if (value !== this.formData.password) {
        callback(new Error('两次输入密码不一致!'));
        return
      } else {
        callback();
      }
    };
    return {
      formData: {
        oldPassword: '',
        password: '',
        checkWord: '',
        loginName: '',
      },
      rules: {
        loginName: [{ required: true, message: '请输入用户名', trigger: 'change,blur' }],
        oldPassword: [
          {required: true,message: '请输入原密码', trigger: 'change,blur' },
        ],
        password: [
          { required: true,message: '请输入新密码', trigger: 'change,blur' },
          { validator: validateNewPass, trigger: 'change,blur',  }
        ],
        checkWord: [{ required: true,validator: validatePass, trigger: 'change,blur'}]
      }
    }
  },
  created() {
    this.popupMsg();
  },
  methods: {
    popupMsg() {
      const user = sessionStorage.getItem('firstLoginUserName');
      this.formData.loginName = user || '';
    },
    makeSure(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          checkOldPassword(this.formData.loginName, this.formData.oldPassword).then(res => {
            // 校验密码强度类型
            this.checkPassword(this.formData.loginName, this.formData.password).then(res => {
              const { password, oldPassword, loginName } = this.formData;
              updateFirstLogin({ newPassword: password, oldPassword, loginName }).then(res => {
                this.$message({
                  message: '修改成功,请重新登录',
                  onClose: function () {
                    logout();
                  }
                })
              });
            });
          })
        } else {
          return false;
        }
      });
    },
    handleLogin() {
      this.$router.push({ name: 'login' });
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/login/passwordReset.vue